const __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/pro-regular-svg-icons/faDisplay");